import config from "@/envConfig/envConfig";
import { uploadData } from "aws-amplify/storage";

export async function uploadFileToBucket(
  file: File,
  folder: string = "product-images",
  // bucketUrl?: string
): Promise<string | any> {
  try {
    const bucketUrl = `https://${config.bucketName}.s3.us-east-1.amazonaws.com/public`;
    if (!bucketUrl) {
      throw new Error("AWS bucket URL environment variable is not defined");
    }

    if (!file) {
      throw new Error("No file provided");
    }

    // Clean the filename by removing spaces
    const fileName = file.name.replace(/\s+/g, "");

    // Create the key (path in the bucket)
    // Use 'public/' prefix to make it publicly accessible
    const key = `${folder}/${fileName}`;

    // Upload the file
    await uploadData({
      key,
      data: file,
      options: {
        contentType: file.type,
      },
    }).result;


    return `${bucketUrl}/${key}`;

  } catch (error) {
    console.error("Error uploading file to bucket:", error);
  }
}
